export const getCounterNumber = (number = 3000000, step = 0.06) => {
  const msElapsed = new Date().getTime() - new Date('2022-01-01').getTime();
  const valueElapsed = (msElapsed / 1000) * step;
  return number + valueElapsed;
};
